import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function RecipeCardDrink(props) {
  const { recipe, index } = props;
  return (
    <div data-testid={ `${index}-recipe-card` } className="recipe-card">
      <Link to={ `/drinks/${recipe.idDrink}` }>
        <h2 data-testid={ `${index}-card-name` } className="recipe-card-title">
          {recipe.strDrink}
        </h2>
        <img
          data-testid={ `${index}-card-img` }
          alt={ `${recipe.strDrink}` }
          src={ recipe.strDrinkThumb }
          className="recipe-card-img"
        />
      </Link>
    </div>
  );
}

RecipeCardDrink.propTypes = {
  recipe: PropTypes.object,
  index: PropTypes.number,
}.isRequired;

export default RecipeCardDrink;
